module.exports = __webpack_public_path__ + "fbd7b711acd2952116afe38853c94b56.svg";